/**
 * Which program version a workflow's diagram shows.
 */

import type { ProgramRow } from "@/lib/scoring/api";

/** The version a workflow's diagram shows: the published one, or else the newest. */
export function pickVersion(rows: ProgramRow[], workflow: string): ProgramRow | null {
  const mine = rows.filter((row) => row.workflow === workflow);
  const published = mine.find((row) => row.status === "PUBLISHED");
  if (published) return published;
  return mine.reduce<ProgramRow | null>(
    (best, row) => (best === null || row.version > best.version ? row : best),
    null,
  );
}

/**
 * The versions of a workflow no sport owns — Results — to list beside a
 * sport's own programs.
 *
 * Checked by workflow code and a missing sport, not trusted to the query: an
 * older admin API ignores `?workflow=` and would hand back every sport's rows.
 */
export function sharedVersions(rows: ProgramRow[], workflow: string): ProgramRow[] {
  return rows.filter((row) => row.workflow === workflow && !row.sportCode);
}
